export const phoneRegExp = /\(\d{2,}\) \d{4,}-\d{4}/;
export const documentRegExp = /[0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}-?[0-9]{2}/;
export const postalCodeRegExp = /[0-9]{5}-[\d]{3}/;
export const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;